<template>
  <div id="search">
    <div id="search-frame">
      <a-input
        placeholder="キーワード検索"
        id="autocomplete"
        v-bind:value="value"
        v-on:input="changeValue"
      >
        <a-icon slot="suffix" type="search" @click="locate" />
      </a-input>
    </div>
    <div id="search-button" @click="locate">
      <div class="button">
        <span>検索</span>
      </div>
    </div>
    <div id="search-check-box">
      <el-checkbox-group v-model="checkList" class="checkbox-wrap" :min="1">
        <div v-for="(id, index) in options" :key="index">
          <el-checkbox :label="id" class="checkbox">{{
            typeIdMapping[id]
          }}</el-checkbox>
        </div>
      </el-checkbox-group>
    </div>
    <ClickModeSelector />
    <div style="margin-left: auto">
      <a
        href="https://irem-map.how-ma.com/"
        target="_blank"
        style="font-size: medium"
      >
        NOI MAPはこちら
      </a>
    </div>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
import ClickModeSelector from "@/components/ClickModeSelector.vue";

const checkOptions = [1, 3, 4];

const typeIdMapping = {
  1: "区分",
  // 2: "区分（ファミリー）",
  3: "一棟（木）",
  4: "一棟（非木）",
};

const center = { lat: 35.682955, lng: 139.686721 };
// Create a bounding box with sides ~10km away from the center point
const defaultBounds = {
  north: center.lat + 0.1,
  south: center.lat - 0.1,
  east: center.lng + 0.1,
  west: center.lng - 0.1,
};

export default {
  name: "SearchBox",
  components: {
    ClickModeSelector,
  },
  data() {
    return {
      options: checkOptions,
      checkList: [1, 3, 4],
      loaded: false,
      place: "",
      value: "",
      origin: null,
      geocoder: null,
      typeIdMapping: typeIdMapping,
      autoCompleteOptions: {
        bounds: defaultBounds,
        componentRestrictions: { country: "jp" },
        fields: ["address_components", "geometry"],
        strictBounds: false,
        types: ["(regions)"],
      },
    };
  },
  computed: {
    google: gmapApi,
  },
  methods: {
    onChange(checkedList) {
      console.log("checkedList");
      this.indeterminate = originAutocomplete.getPlace();
      !!checkedList.length && checkedList.length < plainOptions.length;
      this.checkAll = checkedList.length === plainOptions.length;
    },
    modifyLocation() {
      let location = {
        lat: this.place.geometry.location.lat(),
        lng: this.place.geometry.location.lng(),
      };
      this.$bus.$emit("location", location);
    },
    changeValue: function (e) {
      this.value = e.target.value;
    },
    locate: function () {
      if (this.value == "") {
        return;
      }
      this.geocoder.geocode({ address: this.value }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.place = results[0];
          this.modifyLocation();
        }
      });
    },
  },
  async mounted() {
    await this.$gmapApiPromiseLazy();
    this.loaded = true;
  },

  watch: {
    loaded() {
      // this.origin = new google.maps.places.Autocomplete(
      //   // this.$refs["origin"],
      //   document.getElementById("autocomplete"),
      //   this.autoCompleteOptions
      // );

      // this.origin.addListener("place_changed", () => {
      //   console.log("aaa", this.origin);
      //   this.place = this.origin.getPlace();
      //   this.modifyLocation();
      // });

      this.geocoder = new google.maps.Geocoder();
    },
    checkList: {
      immediate: true,
      handler(val) {
        setTimeout(() => {
          this.$bus.$emit("checkList", val);
        });
      },
    },
  },
};
</script>

<style lang="scss">
#search {
  // width: 75%;
  // max-width: 1200px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  margin-bottom: 10px;

  &-frame {
    min-width: 100px;
    margin-right: 20px;
  }

  & > #search-frame {
    max-width: 450px;

    height: 40px;
    flex: 1;

    & > .ant-input-affix-wrapper {
      height: 100% !important;

      & > .ant-input {
        height: 100% !important;
      }
    }
  }

  &-button > .button {
    width: 120px;
    height: 40px;
    background: #00365b;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    box-shadow: 2px 2px 5px #000;
    margin: 0 10px;
    cursor: pointer;
  }

  &-check-box {
    width: 350px;
    min-width: 350px;
    margin-right: 20px;
    position: relative;
    top: 10px;
  }

  &-check-box > .checkbox-wrap {
    display: flex;
    width: 100%;
    font-size: 14px;
    justify-content: space-between;

    & > div {
      margin-left: 20px;
    }
  }
}

.checkbox {
  cursor: pointer;
  zoom: 140%;
  font-size: 10px;
}

.el-checkbox {
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }

  .el-checkbox__inner {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    margin: 0 0px;

    &::after {
      border: 2px solid #fff;
      width: 7px;
      height: 12px;
      border-left: 0;
      border-top: 0;
      left: 6px;
    }
  }

  &__input.is-checked .el-checkbox__inner {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border-color: #00365b;
    background-color: #00365b;
  }
}
</style>
